import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from './Row.style.js';

const Row = _ref => {
  let {
    as,
    alignItems,
    children,
    className,
    gap,
    justifyContent,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledRow, _extends({
    as: as,
    className: className
  }, rest, {
    $alignItems: alignItems,
    $gap: gap,
    $justifyContent: justifyContent
  }), children);
};
const ALIGN_ITEMS = ['start', 'center', 'end'];
const JUSTIFY_CONTENT = ['start', 'end', 'center', 'between', 'around'];
Row.displayName = 'Row';
Row.propTypes = {
  alignItems: PropTypes.oneOfType([PropTypes.oneOf(ALIGN_ITEMS), PropTypes.shape({
    xs: PropTypes.oneOf(ALIGN_ITEMS),
    sm: PropTypes.oneOf(ALIGN_ITEMS),
    md: PropTypes.oneOf(ALIGN_ITEMS),
    lg: PropTypes.oneOf(ALIGN_ITEMS),
    xl: PropTypes.oneOf(ALIGN_ITEMS)
  })]),
  /**
   * Element or component used for the root node.
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  /**
   * Content of the component.
   */
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  gap: PropTypes.oneOf(['xs', 'md']),
  justifyContent: PropTypes.oneOfType([PropTypes.oneOf(JUSTIFY_CONTENT), PropTypes.shape({
    xs: PropTypes.oneOf(JUSTIFY_CONTENT),
    sm: PropTypes.oneOf(JUSTIFY_CONTENT),
    md: PropTypes.oneOf(JUSTIFY_CONTENT),
    lg: PropTypes.oneOf(JUSTIFY_CONTENT),
    xl: PropTypes.oneOf(JUSTIFY_CONTENT)
  })]),
  role: PropTypes.string
};

export { Row };
